import React from 'react';
import css from './home.module.css';
import cn from 'classnames';

function Home({ content, image, mobileImage }) {
  let images;

  if (mobileImage && mobileImage.url) {
    images = (
      <>
        {image && image.url && (
          <div className={cn(css.imageWrapper, css.desktop)}>
            <img src={image.url} alt={image.alt} />
          </div>
        )}

        {mobileImage && mobileImage.url && (
          <div className={cn(css.imageWrapper, css.mobile)}>
            <img src={mobileImage.url} alt={mobileImage.alt} />
          </div>
        )}
      </>
    );
  } else {
    images = image && image.url && (
      <div className={css.imageWrapper}>
        <img src={image.url} alt={image.alt} />
      </div>
    );
  }
  return (
    <section className={css.home}>
      {images}

      {content && <div className={css.body}>{content}</div>}
    </section>
  );
}

export default Home;
